<template>
  <div>
    <ts-card>
      <div
        class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative"
      >
        {{ data.name }}
        <ts-modal-close-button />
      </div>
    </ts-card>
    <ts-card-wrapper>
      <fieldset>
        <legend>{{ $t('voidInvoice.preview') }}</legend>
        <ts-preview-pdf :src="data.file_url" />
      </fieldset>
    </ts-card-wrapper>
  </div>
</template>

<script>
export default {
  name: 'Audio',
  props: ['data']
}
</script>
